import { render, staticRenderFns } from "./WhyBerza.vue?vue&type=template&id=58af9a34&scoped=true&"
import script from "./WhyBerza.vue?vue&type=script&lang=js&"
export * from "./WhyBerza.vue?vue&type=script&lang=js&"
import style0 from "./WhyBerza.vue?vue&type=style&index=0&id=58af9a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af9a34",
  null
  
)

export default component.exports